export default __webpack_public_path__ + "static/media/august2024-3.08aa5116.jpg";